import { useFormContext } from 'react-hook-form'

import {
  ControlledNumberInput,
  FormError,
  FormField,
  FormItem,
  FormLabel,
} from '@fortem-monorepo/react-ui'

export interface QuoteFactorFormFieldProps {}

export const QuoteFactorFormField: React.FC<QuoteFactorFormFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ quote_factor: number }>()

  return (
    <FormField
      control={control}
      name="quote_factor"
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Qoute Factor</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput {...register('quote_factor')} thousandSeparator={','} />
          </FormItem>
        )
      }}
    />
  )
}
